const usTimezones = [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Adak",
    "Pacific/Honolulu"
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}
function getVariantId() {
    const xpath = "//input[@name='id']";
    const result = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    );
    const inputElement = result.singleNodeValue;
    if (inputElement) {
        const value = inputElement.value;
        if (value) {
            sendHTTPRequest(value);
        } else {
            setTimeout(() => {
                handleVariantChange();
            }, 500);
        }
    } else {
        console.log("Element not found");
        setTimeout(() => {
            handleVariantChange();
        }, 500);
    }
}

function getDiv() {
    return document.querySelector('.shopify-payment-button');
}

// 创建库存信息元素的函数
function createInventoryElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Inventory-quantity");
    newDiv.style.marginTop = '20px';
    const newSpan = document.createElement("span");
    const newI = document.createElement("i");
    if (data > 10) {
        newSpan.textContent = "Available in U.S. warehouse";
        newI.classList.add("safe");
    } else if (data >= 1) {
        const dataSpan = document.createElement('span');
        dataSpan.textContent = data;
        dataSpan.style.color = '#F37E76';
        dataSpan.style.fontWeight = "bold";
        newSpan.appendChild(document.createTextNode('Only '));
        newSpan.appendChild(dataSpan);
        newSpan.appendChild(document.createTextNode('  left in U.S. warehouse'));
        newI.classList.add("danger");
    }
    newDiv.appendChild(newI);
    newDiv.appendChild(newSpan);
    return newDiv;
}
function createShippingElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Shipping-time");
    newDiv.style.margin = '10px 0px 20px 0px';
    newDiv.style.paddingLeft = '35px';
    const newSpan = document.createElement("span");
    if (data >= 1) {
        const now = new Date();
        // const now = new Date(new Date('2026-11-15T17:10:00'));
        const cutoffTime = new Date(now).setHours(8, 30, 0, 0);
        const endOfDay = new Date(now).setHours(23, 59, 59, 999);
        let hours, minutes;
        let shipDate = new Date(now); 
        let shipText = '';
        if (now < cutoffTime) {
            const diffToday = cutoffTime - now;
            const totalMinutesToday = Math.floor(diffToday / (1000 * 60));
            hours = Math.floor(totalMinutesToday / 60);
            minutes = totalMinutesToday % 60;
        } else {
            const diffTom = endOfDay - now;
            const totalMinutesTom = Math.floor(diffTom / (1000 * 60));
            hours = Math.floor(totalMinutesTom / 60);
            minutes = totalMinutesTom % 60;
            shipDate.setDate(shipDate.getDate() + 1); // 第二天发货
        }
        const timeSpan = document.createElement('span');
        timeSpan.textContent = `${hours} hrs ${minutes} mins`;
        timeSpan.style.color = '#2E7D32'; 
        timeSpan.style.fontWeight = "bold";
        
        newSpan.innerHTML = ''; 
        newSpan.appendChild(document.createTextNode('Order within '));
        newSpan.appendChild(timeSpan);
        
        // 定义节假日数组 (格式: MM-DD)
        const holidays = [
            '12-25', // 圣诞节
            '01-01', // 元旦
            '11-26' // 感恩节 ()
        ];
        
        // 检查日期是否为节假日或周末
        function isHolidayOrWeekend(date) {
            const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            const dayOfWeek = date.getDay();
            return holidays.includes(monthDay) || dayOfWeek === 0 || dayOfWeek === 6; 
        }
        
        // 计算日期
        function calculateDeliveryDate(startDate, businessDays) {
            const deliveryDate = new Date(startDate);
            while (isHolidayOrWeekend(deliveryDate)) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }
            deliveryDate.setDate(deliveryDate.getDate() + businessDays)
            return deliveryDate;
        }
        
        // 格式化日期为 "Month Day" 格式
        function formatDateToMonthDay(date) {
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                                'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames[date.getMonth()];
            const day = date.getDate();
            return `${month} ${day}`;
        }

        // 创建 Free 信息
        const expeditedDiv = document.createElement('div');
        expeditedDiv.style.marginTop = '3px';
        
        const expeditedStrong = document.createElement('strong');
        const expeditedStartDate = new Date(shipDate);
        const expeditedDeliveryDate = calculateDeliveryDate(expeditedStartDate, 5);
        expeditedStrong.textContent = formatDateToMonthDay(expeditedDeliveryDate);
        
        expeditedDiv.appendChild(document.createTextNode('Free Shipping will be delivered on '));
        expeditedDiv.appendChild(expeditedStrong);
        
        // 创建 Express 信息
        const expressDiv = document.createElement('div');
        expressDiv.style.marginTop = '3px';
        
        const expressStrong = document.createElement('strong');
        const expressStartDate = new Date(shipDate);
        const expressDeliveryDate = calculateDeliveryDate(expressStartDate, 2);
        expressStrong.textContent = formatDateToMonthDay(expressDeliveryDate);
        
        expressDiv.appendChild(document.createTextNode('Expedited Shipping will be delivered on '));
        expressDiv.appendChild(expressStrong);
        const mediaQuery = window.matchMedia('(min-width: 750px)');
        if (!mediaQuery.matches) {
            newDiv.style.paddingLeft = '0px';
        }
        newDiv.appendChild(newSpan);
        newDiv.appendChild(expressDiv);
        newDiv.appendChild(expeditedDiv);
    } 
    return newDiv;
}

async function sendHTTPRequest(variantId) {
    try {
        const response = await fetch(`https://api.laavooextensions.com?variantId=${variantId}`);
        const data = await response.json();
        const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
        if (existingInventoryQuantity) {
            existingInventoryQuantity.remove();
        }

        if(data > 0){
          function insertInventoryElement(target) {
            const newDiv = createInventoryElement(data);
            const shippingElement = createShippingElement(data);
            target.appendChild(newDiv);
            target.appendChild(shippingElement);
          }
        }

        let targetElements = getDiv();
        if (targetElements) {
            insertInventoryElement(targetElements);
        } else {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        const swatches = getDiv();
                        if (swatches) {
                            observer.disconnect();
                            insertInventoryElement(swatches);
                            break;
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }
    await getVariantId();
}

handleVariantChange();
// 监听元素创建并添加事件监听器
const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const inputElement = document.querySelector(".variations");
            if (inputElement) {
                observer.disconnect();
                inputElement.addEventListener("click", () => {
                    setTimeout(() => {
                        handleVariantChange();
                    }, 100);
                });
                break;
            }
        }
    }
});
observer.observe(document.body, { childList: true, subtree: true });